/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Average_ScoreInputs */

const en_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average Score`)
};

const de_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschnittliche Bewertung`)
};

const fr_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score moyen`)
};

const es_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación promedio`)
};

const it_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio medio`)
};

const nl_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemiddelde score`)
};

const pl_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Średni wynik`)
};

const fi_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskimääräinen pistemäärä`)
};

const da_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemsnitlig score`)
};

const sv_interview_practice_average_score = /** @type {(inputs: Interview_Practice_Average_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genomsnittlig poäng`)
};

/**
* | output |
* | --- |
* | "Average Score" |
*
* @param {Interview_Practice_Average_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_average_score = /** @type {((inputs?: Interview_Practice_Average_ScoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Average_ScoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_average_score(inputs)
	if (locale === "fr") return fr_interview_practice_average_score(inputs)
	if (locale === "es") return es_interview_practice_average_score(inputs)
	if (locale === "it") return it_interview_practice_average_score(inputs)
	if (locale === "nl") return nl_interview_practice_average_score(inputs)
	if (locale === "pl") return pl_interview_practice_average_score(inputs)
	if (locale === "fi") return fi_interview_practice_average_score(inputs)
	if (locale === "da") return da_interview_practice_average_score(inputs)
	if (locale === "sv") return sv_interview_practice_average_score(inputs)
	return en_interview_practice_average_score(inputs)
});